var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-half" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Name")]),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.entity.name,
                  expression: "entity.name",
                },
                { name: "focus-inserted", rawName: "v-focus-inserted" },
              ],
              staticClass: "input is-capitalized",
              class: {
                "is-danger": _vm.$v.entity.name.$error,
                "is-warning": _vm.nameExists,
              },
              attrs: {
                name: "name",
                type: "text",
                placeholder: "Insurer Name",
                maxlength: "120",
              },
              domProps: { value: _vm.entity.name },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.entity, "name", $event.target.value)
                  },
                  function ($event) {
                    _vm.$v.entity.name.$touch()
                    _vm.checkNameExists()
                  },
                ],
              },
            }),
            _vm.$v.entity && !_vm.$v.entity.name.required
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Name is required. "),
                ])
              : _vm._e(),
            _vm.nameExists
              ? _c("span", { staticClass: "help is-warning" }, [
                  _vm._v("Name already exists. "),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c(
                    "div",
                    { staticClass: "control has-icons-right" },
                    [
                      _vm.$company.info &&
                      _vm.$company.info.countryCode === "AU"
                        ? _c("the-mask", {
                            staticClass: "input",
                            class: { "is-danger": _vm.$v.entity.abn.$error },
                            attrs: {
                              type: "text",
                              placeholder: "ABN",
                              mask: ["## ### ### ###"],
                            },
                            nativeOn: {
                              input: function ($event) {
                                return _vm.$v.entity.abn.$touch()
                              },
                            },
                            model: {
                              value: _vm.entity.abn,
                              callback: function ($$v) {
                                _vm.$set(_vm.entity, "abn", $$v)
                              },
                              expression: "entity.abn",
                            },
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.entity.abn,
                                expression: "entity.abn",
                              },
                            ],
                            ref: "abn",
                            staticClass: "input is-uppercase",
                            attrs: { id: "abn", maxlength: "12" },
                            domProps: { value: _vm.entity.abn },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.entity,
                                    "abn",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  return _vm.$v.entity.abn.$touch()
                                },
                              ],
                            },
                          }),
                      !_vm.$v.entity.abn.$error &&
                      _vm.entity.abn &&
                      _vm.$company.info &&
                      _vm.$company.info.countryCode === "AU"
                        ? _c(
                            "span",
                            { staticClass: "icon has-text-success is-right" },
                            [_c("i", { staticClass: "mdi mdi-check mdi-18px" })]
                          )
                        : _vm._e(),
                      _vm.$v.entity && !_vm.$v.entity.abn.minLength
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(
                              "ABN must be at least " +
                                _vm._s(
                                  _vm.$v.entity.abn.$params.minLength.min
                                ) +
                                " letters."
                            ),
                          ])
                        : _vm.$v.entity && !_vm.$v.entity.abn.validAbn
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("ABN format is invalid."),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "column" }, [
              _c("label", { staticClass: "label" }, [_vm._v("ARBN")]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c(
                    "div",
                    { staticClass: "control has-icons-right" },
                    [
                      _c("the-mask", {
                        staticClass: "input",
                        class: { "is-danger": _vm.$v.entity.arbn.$error },
                        attrs: {
                          type: "text",
                          placeholder: "ARBN",
                          mask: ["### ### ###"],
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.$v.entity.arbn.$touch()
                          },
                        },
                        model: {
                          value: _vm.entity.arbn,
                          callback: function ($$v) {
                            _vm.$set(_vm.entity, "arbn", $$v)
                          },
                          expression: "entity.arbn",
                        },
                      }),
                      !_vm.$v.entity.arbn.$error && _vm.entity.arbn
                        ? _c(
                            "span",
                            { staticClass: "icon has-text-success is-right" },
                            [_c("i", { staticClass: "mdi mdi-check mdi-18px" })]
                          )
                        : _vm._e(),
                      _vm.$v.entity && !_vm.$v.entity.arbn.minLength
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(
                              "ARBN must be at least " +
                                _vm._s(
                                  _vm.$v.entity.arbn.$params.minLength.min
                                ) +
                                " letters."
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("G/L Account")]),
          _c(
            "div",
            { staticClass: "control" },
            [
              _vm.glAccountListCombo
                ? _c(
                    "multiselect",
                    {
                      attrs: {
                        options: _vm.glAccountListCombo,
                        placeholder: "Select account",
                        label: "displayName",
                        "track-by": "accountNo",
                        "deselect-label": "Can't remove this value",
                        "allow-empty": false,
                      },
                      model: {
                        value: _vm.selectedGlAccountObject,
                        callback: function ($$v) {
                          _vm.selectedGlAccountObject = $$v
                        },
                        expression: "selectedGlAccountObject",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "has-text-danger",
                          attrs: { slot: "noResult" },
                          slot: "noResult",
                        },
                        [_vm._v("G/L account not found.")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Repairer ID")]),
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field is-narrow" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.repairerId,
                      expression: "entity.repairerId",
                    },
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "Repairer ID" },
                  domProps: { value: _vm.entity.repairerId },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.entity, "repairerId", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("BSB")]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        staticClass: "input",
                        class: { "is-danger": _vm.$v.entity.bsb.$error },
                        attrs: {
                          type: "text",
                          placeholder: "BSB",
                          mask: ["###-###"],
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.$v.entity.bsb.$touch()
                          },
                        },
                        model: {
                          value: _vm.entity.bsb,
                          callback: function ($$v) {
                            _vm.$set(_vm.entity, "bsb", $$v)
                          },
                          expression: "entity.bsb",
                        },
                      }),
                      _vm.$v.entity && !_vm.$v.entity.bsb.minLength
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(
                              "BSB must be at least " +
                                _vm._s(
                                  _vm.$v.entity.bsb.$params.minLength.min
                                ) +
                                " letters."
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "column" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Account No.")]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.accoutNo,
                          expression: "entity.accoutNo",
                        },
                      ],
                      staticClass: "input uppercase",
                      attrs: { type: "text", placeholder: "Account No." },
                      domProps: { value: _vm.entity.accoutNo },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.entity, "accoutNo", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "pretty p-icon p-curve p-smooth p-bigger" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.entity.exported,
                expression: "entity.exported",
              },
            ],
            attrs: { type: "checkbox", disabled: !_vm.$userInfo.isSupportUser },
            domProps: {
              checked: Array.isArray(_vm.entity.exported)
                ? _vm._i(_vm.entity.exported, null) > -1
                : _vm.entity.exported,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.entity.exported,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.entity, "exported", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.entity,
                        "exported",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.entity, "exported", $$c)
                }
              },
            },
          }),
          _vm._m(0),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _vm.$user.hasDelete(_vm.$route.meta.id)
          ? _c("div", { staticClass: "buttons has-addons is-centered" }, [
              _c(
                "span",
                {
                  staticClass: "button",
                  class: { "is-success is-selected": _vm.entity.active },
                  on: {
                    click: function ($event) {
                      return _vm.toggleActive(true)
                    },
                  },
                },
                [_vm._m(1), _c("span", [_vm._v("Active")])]
              ),
              _c(
                "span",
                {
                  staticClass: "button",
                  class: { "is-danger is-selected": !_vm.entity.active },
                  on: {
                    click: function ($event) {
                      return _vm.toggleActive(false)
                    },
                  },
                },
                [_vm._m(2), _c("span", [_vm._v("In-Active")])]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "tile is-parent" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Times & Method")]),
        _c("label", { staticClass: "label" }, [_vm._v("Labour Times")]),
        _c("div", { staticClass: "field is-grouped" }, [
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "select" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.labourType,
                      expression: "entity.labourType",
                    },
                  ],
                  staticClass: "select-width",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.entity,
                        "labourType",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(
                  _vm.labourTimesTypeEnum,
                  function (labourType, propertyName, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: propertyName } },
                      [_vm._v(" " + _vm._s(labourType) + " ")]
                    )
                  }
                ),
                0
              ),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isNtar,
                  expression: "isNtar",
                },
              ],
              staticClass: "field has-checkradio",
            },
            [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.autoPaintLoading,
                      expression: "entity.autoPaintLoading",
                    },
                  ],
                  staticClass: "is-checkradio is-primary",
                  class: {
                    "has-background-color": _vm.entity.autoPaintLoading,
                  },
                  attrs: {
                    id: "auto-paint-loading",
                    type: "checkbox",
                    name: "auto-paint-loading",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.entity.autoPaintLoading)
                      ? _vm._i(_vm.entity.autoPaintLoading, null) > -1
                      : _vm.entity.autoPaintLoading,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.entity.autoPaintLoading,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.entity,
                              "autoPaintLoading",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.entity,
                              "autoPaintLoading",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.entity, "autoPaintLoading", $$c)
                      }
                    },
                  },
                }),
                _c("label", { attrs: { for: "auto-paint-loading" } }, [
                  _vm._v("Auto Paint Loading"),
                ]),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("E-Com Type")]),
              _c("div", { staticClass: "control" }, [
                _c(
                  "div",
                  {
                    staticClass: "select",
                    class: { "is-disabled": _vm.entity.arnie },
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ecomType,
                            expression: "ecomType",
                          },
                        ],
                        staticClass: "select-width",
                        attrs: { disabled: _vm.entity.arnie },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.ecomType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", {
                          domProps: { value: _vm.ecomTypeEnum.None },
                        }),
                        _c(
                          "option",
                          { domProps: { value: _vm.ecomTypeEnum.ORM } },
                          [_vm._v("ORM")]
                        ),
                        _c(
                          "option",
                          { domProps: { value: _vm.ecomTypeEnum.PNET } },
                          [_vm._v("PNET")]
                        ),
                        _c(
                          "option",
                          { domProps: { value: _vm.ecomTypeEnum.EstImage } },
                          [_vm._v("EstImage")]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "column is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Arnie Brand")]),
              _c("div", { staticClass: "control" }, [
                _c(
                  "div",
                  {
                    staticClass: "select",
                    class: { "is-disabled": _vm.entity.pnet || _vm.entity.orm },
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.insurerBrand,
                            expression: "entity.insurerBrand",
                          },
                        ],
                        staticClass: "select-width",
                        attrs: { disabled: _vm.entity.pnet || _vm.entity.orm },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.entity,
                                "insurerBrand",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.onChangeInsurerBrand($event)
                            },
                          ],
                        },
                      },
                      [
                        _c("option"),
                        _vm._l(_vm.arnieBrands, function (brand, index) {
                          return _c(
                            "option",
                            { key: brand, domProps: { value: index + 1 } },
                            [_vm._v(" " + _vm._s(brand) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "column" }, [
              _c("label", { staticClass: "label" }, [_vm._v("RepX Brand")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _vm.repxinsurercodesAvailable
                    ? _c("multiselect", {
                        attrs: {
                          options: _vm.repxinsurercodesAvailable,
                          multiple: true,
                          "close-on-select": false,
                          "clear-on-select": true,
                          "preserve-search": true,
                          taggable: true,
                          placeholder: "Please select RepX brand",
                          label: "code",
                          "track-by": "repxInsurerCodeID",
                          "show-labels": false,
                          disabled: !(_vm.entity.pnet || _vm.entity.orm),
                        },
                        model: {
                          value: _vm.selectedRepxBrandsObject,
                          callback: function ($$v) {
                            _vm.selectedRepxBrandsObject = $$v
                          },
                          expression: "selectedRepxBrandsObject",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Template")]),
          _c(
            "div",
            { staticClass: "control" },
            [
              _vm.quoteTemplateListCombo
                ? _c(
                    "multiselect",
                    {
                      attrs: {
                        options: _vm.quoteTemplateListCombo,
                        placeholder: "Select quote template",
                        label: "name",
                        "track-by": "id",
                      },
                      model: {
                        value: _vm.selectedTemplateObject,
                        callback: function ($$v) {
                          _vm.selectedTemplateObject = $$v
                        },
                        expression: "selectedTemplateObject",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "has-text-danger",
                          attrs: { slot: "noResult" },
                          slot: "noResult",
                        },
                        [_vm._v("Template not found.")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Excess Type")]),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "pretty p-default p-round p-smooth" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.excessGST,
                    expression: "entity.excessGST",
                  },
                ],
                attrs: {
                  id: "chk-pretty-excess-type",
                  name: "chk-pretty-excess-type",
                  type: "radio",
                },
                domProps: {
                  value: false,
                  checked: _vm._q(_vm.entity.excessGST, false),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.entity, "excessGST", false)
                  },
                },
              }),
              _vm._m(3),
            ]),
            _c("div", { staticClass: "pretty p-default p-round p-smooth" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.excessGST,
                    expression: "entity.excessGST",
                  },
                ],
                attrs: {
                  id: "chk-pretty-excess-type",
                  name: "chk-pretty-excess-type",
                  type: "radio",
                },
                domProps: {
                  value: true,
                  checked: _vm._q(_vm.entity.excessGST, true),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.entity, "excessGST", true)
                  },
                },
              }),
              _vm._m(4),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Quoting Method")]),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "pretty p-default p-round p-smooth" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.quotingMethod,
                    expression: "entity.quotingMethod",
                  },
                ],
                attrs: {
                  id: "chk-pretty-quotemethod1",
                  name: "chk-pretty-quotemethod1",
                  type: "radio",
                },
                domProps: {
                  value: "H",
                  checked: _vm._q(_vm.entity.quotingMethod, "H"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.entity, "quotingMethod", "H")
                  },
                },
              }),
              _vm._m(5),
            ]),
            _c("div", { staticClass: "pretty p-default p-round p-smooth" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.entity.quotingMethod,
                    expression: "entity.quotingMethod",
                  },
                ],
                attrs: {
                  id: "chk-pretty-quotemethod2",
                  name: "chk-pretty-quotemethod2",
                  type: "radio",
                },
                domProps: {
                  value: "D",
                  checked: _vm._q(_vm.entity.quotingMethod, "D"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.entity, "quotingMethod", "D")
                  },
                },
              }),
              _vm._m(6),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-narrow" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("AudaNet Settings "),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "pretty p-switch p-fill" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: _vm.entity.audaNetLockType ? true : false,
                    },
                    on: { change: _vm.audaNetLockTypeOnChange },
                  }),
                  _c("div", { staticClass: "state p-primary" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.startCase(
                            Object.keys(_vm.audaNetLockTypes)[
                              _vm.entity.audaNetLockType
                            ]
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "column" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("AudaNet Work Provider Map"),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.audaNetWorkProviderMapping,
                          expression: "entity.audaNetWorkProviderMapping",
                        },
                      ],
                      staticClass: "select-width",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.entity,
                            "audaNetWorkProviderMapping",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option"),
                      _vm._l(
                        _vm.entity.workProviders,
                        function (provider, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: provider } },
                            [_vm._v(" " + _vm._s(provider) + " ")]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field is-flex" }, [
          _c("div", [
            _c("label", { staticClass: "label" }, [_vm._v("Show In Scope")]),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "pretty p-switch p-fill" }, [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { checked: !!_vm.entity.inScope },
                  on: { change: _vm.inScopeOnChange },
                }),
                _c("div", { staticClass: "state p-primary" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.entity.inScope ? "On" : "Off")),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "is-divider-vertical" }),
          _c("div", {}, [
            _c("label", { staticClass: "label" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { enabled: true },
                      expression: "{ enabled: true }",
                    },
                  ],
                  attrs: {
                    content:
                      "Auto transition job stage to Booked In when setting Estimated Job Start/End",
                  },
                },
                [_vm._v("Auto Booked In ")]
              ),
            ]),
            _c("div", { staticClass: "control" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { enabled: true },
                      expression: "{ enabled: true }",
                    },
                  ],
                  staticClass: "pretty p-switch p-fill",
                  attrs: {
                    content:
                      "Auto transition job stage to Booked In when setting Estimated Job Start/End",
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entity.autoBookedInForDueInOut,
                        expression: "entity.autoBookedInForDueInOut",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: _vm.entity.autoBookedInForDueInOut,
                      checked: Array.isArray(_vm.entity.autoBookedInForDueInOut)
                        ? _vm._i(_vm.entity.autoBookedInForDueInOut, null) > -1
                        : _vm.entity.autoBookedInForDueInOut,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.entity.autoBookedInForDueInOut,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.entity,
                                  "autoBookedInForDueInOut",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.entity,
                                  "autoBookedInForDueInOut",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.entity, "autoBookedInForDueInOut", $$c)
                          }
                        },
                        _vm.autoBookedInOnChange,
                      ],
                    },
                  }),
                  _c("div", { staticClass: "state p-primary" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.entity.autoBookedInForDueInOut ? "On" : "Off"
                        )
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "is-divider-vertical" }),
          _c("div", {}, [
            _vm._m(7),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "pretty p-switch p-fill" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.damageSeverity,
                      expression: "entity.damageSeverity",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.entity.damageSeverity)
                      ? _vm._i(_vm.entity.damageSeverity, null) > -1
                      : _vm.entity.damageSeverity,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.entity.damageSeverity,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.entity,
                              "damageSeverity",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.entity,
                              "damageSeverity",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.entity, "damageSeverity", $$c)
                      }
                    },
                  },
                }),
                _c("div", { staticClass: "state p-primary" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.entity.damageSeverity ? "On" : "Off")),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm.hasPdr ? _c("div", { staticClass: "is-divider" }) : _vm._e(),
        _vm.hasPdr
          ? _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("PDR Type")]),
              _c(
                "div",
                { staticClass: "control" },
                _vm._l(_vm.pdrEnum, function (pdrType, propertyName, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "pretty p-default p-round p-smooth",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.pdrType,
                            expression: "entity.pdrType",
                          },
                        ],
                        attrs: {
                          id: `chk-pretty-pdr${index}`,
                          name: `chk-pretty-${index}`,
                          type: "radio",
                        },
                        domProps: {
                          value: pdrType,
                          checked: _vm._q(_vm.entity.pdrType, pdrType),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.entity, "pdrType", pdrType)
                          },
                        },
                      }),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("label", { attrs: { for: `pdr${index}` } }, [
                          _vm._v(_vm._s(propertyName)),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Exported")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Excess (Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Excess (Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Hour")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", [_vm._v("Dollar")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "label" }, [
      _c("span", [_vm._v(" Show Damage Severity ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }